export function serializeTranslationFile(key: string, tekst: string): string {
  // Multi-line values need YAML block scalar
  if (tekst.includes('\n')) {
    // Indent each line of the text for YAML block scalar
    const indented = tekst
      .split('\n')
      .map((line) => (line.trim() ? `  ${line}` : ''))
      .join('\n');
    return `---\nkey: ${key}\ntekst: >\n${indented}\n---\n`;
  }

  // Single line: use plain value, escaping if needed
  const needsQuote = tekst.includes(':') || tekst.includes('#');
  const value = needsQuote ? `"${tekst.replace(/"/g, '\\"')}"` : tekst;
  return `---\nkey: ${key}\ntekst: ${value}\n---\n`;
}

export function serializeContentFile(
  frontmatter: Record<string, string>,
  body: string
): string {
  const lines = Object.entries(frontmatter)
    .filter(([, v]) => v !== undefined && v !== '')
    .map(([k, v]) => {
      const needsQuote = v.includes(':') || v.includes('#') || v.includes('"');
      const value = needsQuote ? `"${v.replace(/"/g, '\\"')}"` : v;
      return `${k}: ${value}`;
    });

  const fm = lines.join('\n');
  return `---\n${fm}\n---\n${body ? `\n${body}\n` : ''}`;
}

export function generateSlug(title: string): string {
  return title
    .toLowerCase()
    .replace(/[äöüõ]/g, (c) => ({ ä: 'a', ö: 'o', ü: 'u', õ: 'o' })[c] || c)
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .trim();
}
